import { useMutation } from '@tanstack/react-query';

import { uploadFileToS3 } from '@/helpers';
import { useApiMutation, useApiQuery, useFetch } from '@/modules/common';

import { Mask, MaskUploadUrlData } from '../types';

export function useMaskDetails(maskId: string) {
  const fetchClient = useFetch();

  const getUploadUrlDataMutation = useMutation<
    MaskUploadUrlData & { file: File },
    undefined,
    { file: File }
  >({
    mutationFn: async ({ file }) => {
      const res = await fetchClient(`/masks/reupload-url/${maskId}`, {
        method: 'GET',
      });
      return { ...res, file };
    },
    onSuccess: async ({ uploadUrl, file }) => {
      await uploadFileToS3({
        file,
        uploadUrl: uploadUrl,
      });
    },
  });

  const { isFetching, data, refetch } = useApiQuery<Mask>(`/masks/${maskId}`, {
    queryKey: ['maskDetails', maskId],
    initialData: null,
  });

  const updateMaskMutation = useApiMutation<Mask>(
    '/masks',
    {
      method: 'PATCH',
    },
    {
      onSuccess: () => {
        refetch();
      },
    }
  );

  const processMaskMutation = useApiMutation<void>(`/masks/${maskId}/process`, {
    method: 'POST',
  });

  return {
    isFetching,
    getUploadUrlDataMutation,
    details: data,
    updateMaskMutation,
    processMaskMutation,
  } as const;
}
